import React from "react";
import { useSkin } from "../../skins/SkinContext";
import { SkRect } from "../../prim";
import { skSun, skCloud, skTree, skHouse, skPerson, skFlower } from "../../actors3";

/*
 * Anivaze v3 — a full-canvas scene composed from skin-aware ACTORS. It reads the
 * GLOBAL skin (no internal SkinProvider), so the style picker re-renders the
 * whole scene in Studio / Hand-drawn / Flat / Doodle. This is the reference for
 * how rebuilt scenes look. See design-plan/v3/PLAN.md.
 */
export interface SkinLandscapeSceneProps {
  opacity?: number;
  accentColor?: string;
  label?: string;
  t?: number;
}

export const SkinLandscapeScene: React.FC<SkinLandscapeSceneProps> = ({ opacity = 1, t = 0, label = "Same scene — pick a style up top to re-skin it!" }) => {
  const skin = useSkin();
  const ground = 330;
  const cloudX = ((t * 16) % 1040) - 80;
  const cloud2X = ((t * 11 + 500) % 1040) - 80;
  return (
    <g opacity={opacity}>
      {/* surface (per skin) + grass */}
      <rect width={800} height={450} fill={skin.surface} />
      <SkRect x={0} y={ground} w={800} h={450 - ground} fill="#86efac" seed={601} />

      {skSun(110, 84, t, 1.1)}
      <g>{skCloud(cloudX, 86, 1)}</g>
      <g>{skCloud(cloud2X, 130, 0.75)}</g>

      {skTree(150, ground, t, 1.15)}
      {skTree(690, ground, t, 0.95)}
      {skHouse(560, ground, 1.05)}
      {skFlower(300, ground, t, 0.8, "#fb7185")}
      {skFlower(340, ground, t, 0.7, "#a78bfa")}
      {skFlower(470, ground, t, 0.75, "#f59e0b")}
      {skPerson(400, ground, t, 1.5, true)}

      <g transform="translate(400 40)">
        <rect x={-250} y={-22} width={500} height={40} rx={20} fill="rgba(255,255,255,0.86)" stroke="#cbd5e1" strokeWidth={1.5} />
        <text x={0} y={4} textAnchor="middle" fill={skin.textInk} fontSize={16} fontWeight={700} fontFamily={skin.fontFamily}>{label}</text>
      </g>
    </g>
  );
};
